export const openOverlayCard = item => ({
  type: 'onopenoverlaycard',
  item
});

export const closeOverlayCard = () => ({
  type: 'oncloseoverlaycard'
});



// WEBPACK FOOTER //
// ./src/app/actions/overlay.js